//#region src/extensions/paragraph-extension/constants.ts
var e = "extra-spacing";
//#endregion
export { e as PARAGRAPH_EXTRA_SPACING_ATTRIBUTE };
